import {Component, h, Fragment} from "preact";
import {Modal} from "../../_common/components/modal";
import {t} from "../../_i18n";
import {fetchApplications} from "../../_rx/jobs/actions";
import {connect} from "react-redux";
import {C, E} from "../../_common/layout";


type PropsReact = {
    candidateReducer: any,
    id: any
}


class View extends Component<PropsReact, { }> {
    constructor(props: any) {
        super(props);
    }

    render = ({candidateReducer, id}: PropsReact) => (candidateReducer) && <Modal id={id} title={t('Carta de presentación')} className="md-no-fullscreen">
        <hr className="separator-xxs"/>
        <div className="in-modal-scroll">
            <E>
                {candidateReducer?.candidate?.letter && <span dangerouslySetInnerHTML={{ __html:  candidateReducer.candidate.letter.replace(/\n/g, "<br />") }} />}
            </E>
        </div>
    </Modal>

}

const ConnectedView: any = connect(
    ({fixtures, candidateReducer}:any)=>({fixtures, candidateReducer}), {fetchApplications})(View as any);


export default ({id}: any) =>
    <ConnectedView id={id}/>
;